import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            追剧圈正在热议的话题和类型，发现大家都在看什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 text-accent-900 hover:bg-accent-200'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-300/60'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              <span>{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-accent-600' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}